<!--
 * @Author: Mr.Cong Wei
 * @Date: 2022-12-12 16:58:48
 * @LastEditTime: 2022-12-12 17:11:05
-->
<template>
  <div style="position: relative; width: 20px; height: 20px">
    <svg
      version="1.1"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="20px"
      height="20px"
      xmlns="http://www.w3.org/2000/svg"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <g transform="matrix(1 0 0 1 -546 -380 )">
        <path
          d="M 556 380  C 561.6 380  566 384.4  566 390  C 566 395.6  561.6 400  556 400  C 550.4 400  546 395.6  546 390  C 546 384.4  550.4 380  556 380  Z "
          fill-rule="nonzero"
          fill="#018b07"
          stroke="none"
        />
        <path
          d="M 556 380.5  C 561.32 380.5  565.5 384.68  565.5 390  C 565.5 395.32  561.32 399.5  556 399.5  C 550.68 399.5  546.5 395.32  546.5 390  C 546.5 384.68  550.68 380.5  556 380.5  Z "
          stroke-width="1"
          stroke="#ffffff"
          fill="none"
        />
      </g>
    </svg>
    <span
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      style="color: #fff"
    >
      产
    </span>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
